import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Input,
    OnChanges,
    OnInit,
    SimpleChanges,
    ViewEncapsulation,
} from "@angular/core";
import { TypeManagerDecorator } from "../main/type.map.service";
import { S25Util } from "../util/s25-util";
import { BubblePosition, S25BubbleComponent } from "./s25.bubble.component";
import { UserprefService } from "../services/userpref.service";

@TypeManagerDecorator("s25-ng-time-bubble")
@Component({
    selector: "s25-ng-time-bubble",
    template: ` <s25-ng-bubble [position]="position">{{ time }}</s25-ng-bubble> `,
    styles: `
        :host {
            --bubble-color: var(--time-bubble-color, var(--avail-text-color, black));

            display: block;
        }
    `,
    imports: [S25BubbleComponent],
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
})
export class S25TimeBubbleComponent implements OnChanges, OnInit {
    @Input({ required: true }) position: BubblePosition;
    @Input() time: string;
    @Input() hours: number; // Hour of day, float
    @Input() is24Hours: boolean;

    constructor(private cd: ChangeDetectorRef) {}

    ngOnChanges(changes: SimpleChanges) {
        if (changes.hours || changes.is24Hours) this.onHoursChange();
    }

    async ngOnInit() {
        if (this.is24Hours === undefined) {
            this.is24Hours = await UserprefService.getIs24HourTime();
            this.onHoursChange();
        }
    }

    onHoursChange() {
        if (typeof this.hours !== "number") return;
        this.time = S25Util.date.toTimeStrFromHours(this.hours, this.is24Hours);
        this.cd.detectChanges();
    }
}
